/**
 * Gets the days of the week numbered 0 to 6
 *
 * @returns - An array with each day of the week
 */
export function getDaysOfWeek(): number[] {
    return Array(7)
        .fill(null)
        .map((_, index) => index);
}
